<!-- Spinner -->
<ng-template #spinner>
  <medsurf-design-content-process-spinner></medsurf-design-content-process-spinner>
</ng-template>

<!-- Content -->
@if (nodeSharedFacade.currentSelectedPage$ | async; as page) {
  @if (page) {
    <div class="flex flex-1 flex-column w-full m-2">
      <!-- Card -->
      <div class="flex p-card p-component h-full">
        <div class="flex flex-1 flex-column w-full p-card-body">
          <div class="p-card-title">
            <medsurf-design-form-control-form
              [formGroup]="titleForm"
              (onSubmit)="onSubmit()">
              <div class="relative">
                <medsurf-design-form-control-input-text [formField]="false"
                  class="flex-grow-1"
                  [inputClass]="FlatModels.TextDesignModels.TextDesignClass.SLIDE_TITLE"
                  [control]="titleForm.controls.title"
                  [placeholder]="'global.slide_title'"
                  (valueChange)="onSubmit()"></medsurf-design-form-control-input-text>
                <medsurf-design-content-chip 
                  [tooltipLabel]="('enum.pageType.' + page.type) | translate" 
                  class="absolute z-1 right-0 top-0 m-2"
                >
                  <span 
                    [class]="FlatModels.PageEntityModels.PageTypeIcon[page.type]"
                  ></span>
                </medsurf-design-content-chip>
              </div>
            </medsurf-design-form-control-form>
            <div class="relative">
              <div class="absolute right-0 mt-2">
                <!-- Edited By -->
                @if ({
                  at: page?.editedAt,
                  user: appSharedFacade.user$(page.editedBy) | async
                }; as edited) {
                  @if (edited.at) {
                    @if ({
                      edited: (edited.at | date_shared) + (edited.user ? ' (' + (edited.user.firstName && edited.user.lastName ? edited.user.firstName + ' ' + edited.user.lastName : edited.user.email) + ')' : '')
                    }; as output) {
                      <div 
                        class="text-sm edited-by font-normal" 
                        [title]="('global.last_changed' | translate) + ': ' + (output.edited)"
                      >
                        <span class="fa fa-clock-rotate-left"></span>
                        {{ output.edited }}
                      </div>
                    }
                  }
                }
              </div>
            </div>
          </div>
          <div class="p-card-content h-full overflow-hidden pb-0">
            @if (activeIndex !== undefined) {
              <p-tabView #chapterMainTabView
                         [activeIndex]="activeIndex()"
                         class="w-full"
                styleClass="flex flex-column h-full">
                @if (FlatModels.PageEntityModels.PageHasSlides(page)) {
                  <p-tabPanel
                    [header]="'global.slides' | translate"
                    class="flex max-h-full">
                    <medsurf-chapter-main-slides class="w-full"></medsurf-chapter-main-slides>
                  </p-tabPanel>
                }
                @if (page.type === 'Vocabulary') {
                  <p-tabPanel
                    [header]="'global.vocabulary' | translate"
                    class="flex max-h-full">
                    <div class="flex overflow-auto w-full h-screen max-h-full mt-2">
                      <medsurf-chapter-main-vocabulary class="w-full"></medsurf-chapter-main-vocabulary>
                    </div>
                  </p-tabPanel>
                }
                @if (page.type === 'QuizStart') {
                  <p-tabPanel
                    [header]="'global.quiz' | translate"
                    class="flex max-h-full">
                    <div class="flex overflow-auto w-full h-screen max-h-full">
                      <medsurf-chapter-main-quiz-start class="w-full"></medsurf-chapter-main-quiz-start>
                    </div>
                  </p-tabPanel>
                }
                @if (FlatModels.PageEntityModels.PageHasBody(page)) {
                  <p-tabPanel
                    [header]="'global.body' | translate"
                    class="flex max-h-full">
                    <div class="flex overflow-auto w-full h-screen max-h-full pt-2">
                      <medsurf-chapter-main-body class="w-full"></medsurf-chapter-main-body>
                    </div>
                  </p-tabPanel>
                }
                <!--                   [selected]="!FlatModels.PageEntityModels.PageHasSlides.has(page.type) && page.type !== 'Vocabulary' && page.type !== 'QuizStart'" -->
                @if (FlatModels.PageEntityModels.PageHasDescription(page)) {
                  <p-tabPanel
                    [header]="'global.description' | translate"
                    class="flex max-h-full">
                    <div class="flex overflow-auto w-full h-screen max-h-full pt-2">
                      <medsurf-chapter-main-description class="w-full"></medsurf-chapter-main-description>
                    </div>
                  </p-tabPanel>
                }
                <p-tabPanel [header]="'global.settings' | translate"
                  class="flex max-h-full">
                  <div class="flex overflow-auto w-full h-screen max-h-full mt-2">
                    <medsurf-chapter-main-settings class="w-full"></medsurf-chapter-main-settings>
                  </div>
                </p-tabPanel>
                @if (FlatModels.PageEntityModels.PageCanGeneratePdf(page)) {
                  <p-tabPanel [header]="'global.pdf_generate' | translate"
                    class="flex max-h-full">
                    <div class="flex overflow-auto w-full h-screen max-h-full mt-2">
                      <medsurf-chapter-main-generate class="w-full"></medsurf-chapter-main-generate>
                    </div>
                  </p-tabPanel>
                }
                <p-tabPanel [header]="'global.text_export' | translate"
                  class="flex max-h-full">
                  <div class="flex overflow-auto w-full h-screen max-h-full mt-2">
                    <medsurf-chapter-main-export class="w-full"></medsurf-chapter-main-export>
                  </div>
                </p-tabPanel>
                <p-tabPanel [header]="'global.comments' | translate"
                  class="flex max-h-full">
                  <div class="flex overflow-auto w-full h-screen max-h-full pt-2">
                    <medsurf-chapter-main-comments class="w-full"></medsurf-chapter-main-comments>
                  </div>
                </p-tabPanel>
              </p-tabView>
            }
          </div>
        </div>
      </div>
    </div>
  }
}
